<template>
  <button 
    :disabled="disabled"
    class="back-button flex btn pcIcon h-9 w-32 border-2 border-gray-400 cursor-pointer text-base-content-600 rounded-xl text-base justify-center items-center font-semibold nativeButton bg-white hover:bg-gray-200 focus:bg-gray-100 transition-all flex-nowrap"
    @click="$emit('click')"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-arrow-left-short arrowIcon flex-shrink-0" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/> </svg>
    {{ $t('actions.previous') }}
  </button>
</template>

<script>
export default {
  name: "BackButton",

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.back-button {
  padding: 0 !important;
  min-height: unset;
  text-transform: none;
}
</style>
